export const LOG_EVENT_TYPE_CHART_DRAG_STARTED="DRAG STARTED"

export const LOG_EVENT_TYPE_CHART_DRAG_ENDED="DRAG ENDED"

export const LOG_EVENT_TYPE_CHART_PREDICTION_STARTED="PREDICTION STARTED"

export const LOG_EVENT_TYPE_CHART_PREDICTION_ENDED="PREDICTION ENDED"

export const LOG_EVENT_TYPE_CHART_BRUSHING_STARTED="BRUSHING STARTED"

export const LOG_EVENT_TYPE_CHART_BRUSHING_ENDED="BRUSHING ENDED"

export const LOG_EVENT_TYPE_CHART_PREDICTION_CLEARED="PREDICTION CLEARED"

export const LOG_EVENT_TYPE_CHART_DESTROYED="CHART DESTROYED"

export const LOG_EVENT_TYPE_CHART_CREATED="CHART CREATED"

export const LOG_EVENT_TYPE_CHART_PREDICTION_PAGE="CHART PREDICTION PAGE"

export const LOG_EVENT_TYPE_CHART_SEE_DATA_PAGE="CHART SEE DATA PAGE"

export const LOG_EVENT_TYPE_CHART_BRUSHING_CLICKED="BRUSHING CLICKED"

export const LOG_EVENT_TYPE_CHART_BRUSHING_UNCLICKED="BRUSHING UNCLICKED"


export const LOG_EVENT_TYPE_CHART_BRUSHING_CLEARED="BRUSHING CLEARED"

export const LOG_EVENT_TYPE_PAGE_REFRESHED="PAGE REFRESHED"